import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function apiCall(
	nutrientId: string,
	pointType: 'StandardFood' | 'Cheese' | 'Beverage' | 'AddedFat' | 'Water'
): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/NutriScoreNutrientPoints/${nutrientId}`;
	return axios
		.delete(url, {
			params: {
				PointType: pointType,
			},
		})
		.toOptionalVoid();
}
